export const globalStyle = `
  body, #root {
    margin: 0;
    padding: 0;
    width: 100vw;
    overflow-x: hidden;
    background-color: #EEE;
  }
`;

export const styles = {
    pageContainer: {
        width: '100vw',
        minHeight: '100vh',
        margin: 0,
        padding: 0,
        backgroundColor: '#EEE',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0
    },
    contentPadding: {
        padding: '18px 30px',
        backgroundColor: '#EEE',
        width: '100%',
        boxSizing: 'border-box'
    },
    subHeading: {
        fontSize: '15px',
        color: '#666',
        marginBottom: '16px',
        fontStyle: 'normal',
        fontWeight: '700',
        textAlign: 'left'
    },
    surveyList: {
        width: '100vw',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'white',
        position: 'relative',
        left: '50%',
        right: '50%',
        marginLeft: '-50vw',
        marginRight: '-50vw'
    },
    surveyItem: {
        display: 'flex',
        padding: '18px 30px',
        alignItems: 'center',
        borderTop: '1px solid #D8D8D8',
        borderBottom: '1px solid #D8D8D8',
        textDecoration: 'none',
        color: '#0066CC',
        backgroundColor: '#fff',
        fontSize: '13px',
        width: '100%',
        boxSizing: 'border-box',
        fontWeight: '500',
        ':focus': {
            outline: '3px solid #4A90E2',
            outlineOffset: '2px',
            backgroundColor: '#f5f5f5'
        }
    },
    skipLink: {
        position: 'absolute',
        left: '-9999px',
        top: 'auto',
        width: '1px',
        height: '1px',
        overflow: 'hidden',
        ':focus': {
            position: 'static',
            width: 'auto',
            height: 'auto',
            padding: '10px',
            backgroundColor: '#fff',
            zIndex: 2000
        }
    },
    loadingError: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#EEE',
        zIndex: 1000,
        width: '100vw'
    },
    messageText: {
        textAlign: 'center',
        color: '#333',
        fontSize: '18px',
        fontWeight: '700'
    }
};